module.exports = __webpack_public_path__ + "static/img/honor01.3af0a96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/honor01.jpg
// module id = 0y6z
// module chunks = 0